import {actions} from '../../actions/account/account';

export default function account(initialState = {}, action) {
    const newState = {...initialState};

    switch (action.type) {
        case actions.SET_ACCOUNT: return setAccount(newState, action.account);
        case actions.SET_TRANSACTION_HISTORY: return setTransactionHistory(newState, action.transactionHistory);
        case actions.SET_TRANSACTION_RECEIPT: return setTransactionReceipt(newState, action.transactionReceipt);
        case actions.SET_PREFERENCES: return setPreferences(newState, action.preferences);
        case actions.UPDATE_CONTACT_DETAILS: return updateContactDetails(newState, action._contactDetails);
        case actions.UPDATE_CONTACT_DETAILS_REQUEST: return updateContactDetailsRequest(newState, null);
        case actions.UPDATE_PREFERENCES: return updatePreferences(newState, action.preferences);
        case actions.UPDATE_PASSWORD: return updatePassword(newState, action.success);
        case actions.GET_PREFERRED_NETWORK: return getPreferredNetwork( newState, action.preferred_network );
        default: return newState;
    }
}

function setAccount(newState, account) {

    newState.account = account;
    return newState;
}

function setPreferences(newState, preferences) {
    newState.account = { ...newState.account};
    newState.preferences = preferences;


    const initialValues = {};

    preferences.map( ( prefs ) => {
        
        let name = null;

        switch( prefs.id ){
            case 10: name = "jobs_member_services";
            break;
            case 11: name = "partnership_member_discounts";
            break;
            default: name = null;
        }

        if( prefs.opted_in === 1 ) {
            initialValues[name] = true;
        }

    } );

    const frequencyExists = preferences.filter( ( prefs ) => prefs.frequency )[0];

    initialValues['frequency'] = frequencyExists ? frequencyExists.frequency : 1;

    newState.initialValues = initialValues;

    return newState;
}

function setTransactionHistory(newState, transactionHistory) {
    newState.account = { ...newState.account };
    newState.transactionHistory = transactionHistory;

    return newState;

}

function setTransactionReceipt( newState, transactionReceipt ) {
    newState.account = { ...newState.account };
    newState.transactionReceipt = transactionReceipt;

    return newState;
}

function updateContactDetails(newState, contactDetails) {
    newState.account = { ...newState.account };
    if( contactDetails.gender_id ) {
        const genderMale = { id: 1, name: "Male" };
        const genderFemale = { id: 2, name: "Female" };
        contactDetails.gender_id === 1 && (contactDetails.gender = genderMale)
        contactDetails.gender_id === 2 && (contactDetails.gender = genderFemale)
        newState.account = { ...contactDetails }
    }
    newState.account.loading = false;
    return newState;
}

function updateContactDetailsRequest(newState) {
    newState.account.loading = true;
    return newState;
}

function updatePreferences(newState, preferences) {
    newState.account = { ...newState.account };
    newState.preferences = preferences;

    const initialValues = {};

    preferences.map( ( prefs ) => {

        let name = null;

        switch( prefs.id ){
            case 10: name = "jobs_member_services";
                break;
            case 11: name = "partnership_member_discounts";
                break;
            default: name = null;
        }

        if( prefs.opted_in === 1 ) {
            initialValues[name] = true;
        }

    } );

    const frequencyExists = preferences.filter( ( prefs ) => prefs.frequency )[0];

    initialValues['frequency'] = frequencyExists ? frequencyExists.frequency : 1;

    newState.initialValues = initialValues;

    return newState;
}

function updatePassword(newState, success) {


    newState.account = {...newState.account};
    newState.password_updated = success;

    return newState;
}

function getPreferredNetwork( newState, network ) {
    if( network.data ) {
        newState.preferred_network = network.data.preferred_network
    } else {
        newState.preferred_network = network;
    }

    return newState;
}



// WEBPACK FOOTER //
// src/client/reducers/account/account.js